<template>
    
   <div class="p-fluid grid">
      <div class="field col-12 md:col-2">
          <label for="cep" class="font-bold required">CEP</label>
          <ValidationProvider name="CEP" rules="required" v-slot="{ errors }" mode="lazy">
              <InputMask id="cep" v-model="endereco.cep" mask="99999-999" @change="setEndereco()"         
        :class="{ 'field-invalid': errors[0] }"/>
            <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
          </ValidationProvider>	     
      </div> 
			<div class="field col-12 md:col-10">
				<label for="endereco" class="font-bold required">Logradouro</label>
        <ValidationProvider name="Logradouro" rules="required" v-slot="{ errors }" mode="lazy">
				  <InputText id="endereco" v-model="endereco.logradouro"  />
            <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
        </ValidationProvider>	          
			</div>
			<div class="field col-12 md:col-2">
				<label for="numero" class="font-bold required">Número</label>		
        <ValidationProvider name="Número" rules="required" v-slot="{ errors }" mode="lazy">
				  <InputText id="numero" v-model="endereco.numero"  />	
           <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
        </ValidationProvider>	
			</div>
			<div class="field col-12 md:col-10">        
				<label for="complemento" class="font-bold">Complemento</label>
        <InputText id="complemento" v-model="endereco.complemento"/>
			</div>

			<div class="field col-12">
				<label for="bairro" class="font-bold required">Bairro</label>					
        <ValidationProvider name="Bairro" rules="required" v-slot="{ errors }" mode="lazy">	
				  <InputText id="bairro" v-model="endereco.bairro"  />
           <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
        </ValidationProvider>	          
			</div>

      <div class="field col-12 md:col-3">
        <label for="estado" class="font-bold required">Estado</label>
        <ValidationProvider name="Estado" rules="required" v-slot="{ errors}" mode="lazy">
            <Dropdown id="estado" v-model="estadoSelecionado" :options="dropdownEstados" @change="setCidades()" style="heigth: 300px" optionLabel="sigla" placeholder="Estado ..."
            :class="{ 'field-invalid': errors[0] }"/>
            <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
        </ValidationProvider> 
		  </div> 

      <div class="field col-12 md:col-6">
          <label for="cidade" class="font-bold required">Cidade</label>          
          <ValidationProvider name="Cidade" rules="required" v-slot="{ errors }" mode="lazy">            
            <Dropdown id="cidade" v-model="endereco.cidade.nome" :options="dropdownCidades" placeholder="Cidade ..."
                  :class="{ 'field-invalid': errors[0]  }"/>
            <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
          </ValidationProvider> 
      </div>

    </div>


</template>

<script>
import { validacaoFormulario } from '@/validacaoFormulario'
import EstatosCidadesService from '../service/EstadosCidadesService'
import axios from 'axios'

export default {

    mixins: [validacaoFormulario],

    props: ['endereco'],

    data() { 
        return {           
            dropdownEstados : [],  
            dropdownCidades : [],
            estadoSelecionado: []
        }
    },
    estatosCidadesService: null,
    created() {
      this.estatosCidadesService = new EstatosCidadesService();
    },

    mounted(){      
      this.cargaEstados();
    },

    methods: {
      setCidades(){   
          if(this.estadoSelecionado){
              this.dropdownCidades = this.estadoSelecionado.cidades
              this.endereco.cidade.estado.uf = this.estadoSelecionado.sigla
          }
      },
      
      getEstadoBySigla(sigla){          
        if(sigla){          
          for (let estado of this.dropdownEstados) {
              if(estado.sigla === sigla) {                        
                return estado;
              }
          }			
        }
        return {cidades: [], nome:'', sigla:''};
      },
      async cargaEstados(){

          await this.estatosCidadesService.getEstadosCidades().then(data => this.dropdownEstados = data);  

          if(this.endereco.cidade.estado.uf){
            this.estadoSelecionado =  this.getEstadoBySigla(this.endereco.cidade.estado.uf);
            this.setCidades();
          }
      }, 

      async setEndereco(){

        await axios.get(`https://viacep.com.br/ws/${this.endereco.cep}/json/`)
                .then(resposta => {                  
                    this.endereco.logradouro = resposta.data.logradouro;
                    this.endereco.bairro = resposta.data.bairro;                   
                    this.endereco.cidade.estado.uf = resposta.data.uf;
                    this.estadoSelecionado =  this.getEstadoBySigla(this.endereco.cidade.estado.uf);
                    this.setCidades();
                    this.endereco.cidade.nome = resposta.data.localidade;                    
                })
                .catch(erro => console.error(erro));           
         
        }

    }
}
</script>

